var cov_2g14hjv15x = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/dom/popover.ts",
      hash = "d9fe35abc7ab54dadffac70a83790351a91c0940",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/dom/popover.ts",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 16
        },
        end: {
          line: 11,
          column: 50
        }
      },
      "1": {
        start: {
          line: 13,
          column: 27
        },
        end: {
          line: 89,
          column: 1
        }
      },
      "2": {
        start: {
          line: 18,
          column: 15
        },
        end: {
          line: 18,
          column: 41
        }
      },
      "3": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 19,
          column: 62
        }
      },
      "4": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 57
        }
      },
      "5": {
        start: {
          line: 20,
          column: 36
        },
        end: {
          line: 20,
          column: 57
        }
      },
      "6": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 21,
          column: 66
        }
      },
      "7": {
        start: {
          line: 21,
          column: 17
        },
        end: {
          line: 21,
          column: 66
        }
      },
      "8": {
        start: {
          line: 22,
          column: 20
        },
        end: {
          line: 22,
          column: 49
        }
      },
      "9": {
        start: {
          line: 23,
          column: 21
        },
        end: {
          line: 23,
          column: 51
        }
      },
      "10": {
        start: {
          line: 25,
          column: 28
        },
        end: {
          line: 25,
          column: 30
        }
      },
      "11": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 80,
          column: 3
        }
      },
      "12": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 60
        }
      },
      "13": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 56
        }
      },
      "14": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 11
        }
      },
      "15": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 32,
          column: 77
        }
      },
      "16": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 33,
          column: 56
        }
      },
      "17": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 11
        }
      },
      "18": {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 82
        }
      },
      "19": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 56
        }
      },
      "20": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 11
        }
      },
      "21": {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 40,
          column: 60
        }
      },
      "22": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 41,
          column: 56
        }
      },
      "23": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 42,
          column: 11
        }
      },
      "24": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 60
        }
      },
      "25": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 45,
          column: 74
        }
      },
      "26": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 11
        }
      },
      "27": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 60
        }
      },
      "28": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 62
        }
      },
      "29": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 50,
          column: 11
        }
      },
      "30": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 73
        }
      },
      "31": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 56
        }
      },
      "32": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 11
        }
      },
      "33": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 56,
          column: 73
        }
      },
      "34": {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 57,
          column: 74
        }
      },
      "35": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 11
        }
      },
      "36": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 73
        }
      },
      "37": {
        start: {
          line: 61,
          column: 6
        },
        end: {
          line: 61,
          column: 62
        }
      },
      "38": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 11
        }
      },
      "39": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 60
        }
      },
      "40": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 65,
          column: 70
        }
      },
      "41": {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 66,
          column: 11
        }
      },
      "42": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 68,
          column: 77
        }
      },
      "43": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 70
        }
      },
      "44": {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 70,
          column: 11
        }
      },
      "45": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 72,
          column: 82
        }
      },
      "46": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 70
        }
      },
      "47": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 11
        }
      },
      "48": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 60
        }
      },
      "49": {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 77,
          column: 56
        }
      },
      "50": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 11
        }
      },
      "51": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 88,
          column: 3
        }
      },
      "52": {
        start: {
          line: 83,
          column: 40
        },
        end: {
          line: 86,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 13,
            column: 28
          }
        },
        loc: {
          start: {
            line: 17,
            column: 5
          },
          end: {
            line: 89,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        },
        loc: {
          start: {
            line: 83,
            column: 40
          },
          end: {
            line: 86,
            column: 5
          }
        },
        line: 83
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 52
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 39
          },
          end: {
            line: 16,
            column: 52
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 57
          }
        }, {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 57
          }
        }],
        line: 20
      },
      "2": {
        loc: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 66
          }
        }, {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 66
          }
        }],
        line: 21
      },
      "3": {
        loc: {
          start: {
            line: 22,
            column: 20
          },
          end: {
            line: 22,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 22,
            column: 32
          },
          end: {
            line: 22,
            column: 33
          }
        }, {
          start: {
            line: 22,
            column: 36
          },
          end: {
            line: 22,
            column: 49
          }
        }],
        line: 22
      },
      "4": {
        loc: {
          start: {
            line: 23,
            column: 21
          },
          end: {
            line: 23,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 23,
            column: 33
          },
          end: {
            line: 23,
            column: 34
          }
        }, {
          start: {
            line: 23,
            column: 37
          },
          end: {
            line: 23,
            column: 51
          }
        }],
        line: 23
      },
      "5": {
        loc: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 80,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 30,
            column: 11
          }
        }, {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 34,
            column: 11
          }
        }, {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 38,
            column: 11
          }
        }, {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 42,
            column: 11
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 46,
            column: 11
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 50,
            column: 11
          }
        }, {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 54,
            column: 11
          }
        }, {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 58,
            column: 11
          }
        }, {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 62,
            column: 11
          }
        }, {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 66,
            column: 11
          }
        }, {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 70,
            column: 11
          }
        }, {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 74,
            column: 11
          }
        }, {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 78,
            column: 11
          }
        }, {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 12
          }
        }],
        line: 26
      },
      "6": {
        loc: {
          start: {
            line: 36,
            column: 19
          },
          end: {
            line: 36,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 19
          },
          end: {
            line: 36,
            column: 38
          }
        }, {
          start: {
            line: 36,
            column: 42
          },
          end: {
            line: 36,
            column: 55
          }
        }],
        line: 36
      },
      "7": {
        loc: {
          start: {
            line: 72,
            column: 19
          },
          end: {
            line: 72,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 19
          },
          end: {
            line: 72,
            column: 38
          }
        }, {
          start: {
            line: 72,
            column: 42
          },
          end: {
            line: 72,
            column: 55
          }
        }],
        line: 72
      },
      "8": {
        loc: {
          start: {
            line: 85,
            column: 13
          },
          end: {
            line: 85,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 85,
            column: 44
          },
          end: {
            line: 85,
            column: 72
          }
        }, {
          start: {
            line: 85,
            column: 75
          },
          end: {
            line: 85,
            column: 81
          }
        }],
        line: 85
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _defineProperty from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { docScroll, docSize } from './document';
var posKeys = (cov_2g14hjv15x.s[0]++, ['left', 'top', 'bottom', 'right']);
cov_2g14hjv15x.s[1]++;
export var getPosition = function getPosition(position, el) {
  var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_2g14hjv15x.b[0][0]++, document.body);
  cov_2g14hjv15x.f[0]++;
  var rect = (cov_2g14hjv15x.s[2]++, el.getBoundingClientRect());
  var containerRect = (cov_2g14hjv15x.s[3]++, {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  });
  cov_2g14hjv15x.s[4]++;

  if (container.tagName === 'BODY') {
    cov_2g14hjv15x.b[1][0]++;
    cov_2g14hjv15x.s[5]++;
    container = undefined;
  } else {
    cov_2g14hjv15x.b[1][1]++;
  }

  cov_2g14hjv15x.s[6]++;

  if (container) {
    cov_2g14hjv15x.b[2][0]++;
    cov_2g14hjv15x.s[7]++;
    containerRect = container.getBoundingClientRect();
  } else {
    cov_2g14hjv15x.b[2][1]++;
  }

  var scrollTop = (cov_2g14hjv15x.s[8]++, container ? (cov_2g14hjv15x.b[3][0]++, 0) : (cov_2g14hjv15x.b[3][1]++, docScroll.top));
  var scrollLeft = (cov_2g14hjv15x.s[9]++, container ? (cov_2g14hjv15x.b[4][0]++, 0) : (cov_2g14hjv15x.b[4][1]++, docScroll.left));
  var pos = (cov_2g14hjv15x.s[10]++, {});
  cov_2g14hjv15x.s[11]++;

  switch (position) {
    case 'top-left':
      cov_2g14hjv15x.b[5][0]++;
      cov_2g14hjv15x.s[12]++;
      pos.left = scrollLeft + rect.left - containerRect.left;
      cov_2g14hjv15x.s[13]++;
      pos.top = scrollTop + rect.top - containerRect.top;
      cov_2g14hjv15x.s[14]++;
      break;

    case 'top':
      cov_2g14hjv15x.b[5][1]++;
      cov_2g14hjv15x.s[15]++;
      pos.left = scrollLeft + rect.left - containerRect.left + rect.width / 2;
      cov_2g14hjv15x.s[16]++;
      pos.top = scrollTop + rect.top - containerRect.top;
      cov_2g14hjv15x.s[17]++;
      break;

    case 'top-right':
      cov_2g14hjv15x.b[5][2]++;
      cov_2g14hjv15x.s[18]++;
      pos.right = ((cov_2g14hjv15x.b[6][0]++, containerRect.right) || (cov_2g14hjv15x.b[6][1]++, docSize.width)) - rect.right - scrollLeft;
      cov_2g14hjv15x.s[19]++;
      pos.top = scrollTop + rect.top - containerRect.top;
      cov_2g14hjv15x.s[20]++;
      break;

    case 'left-top':
      cov_2g14hjv15x.b[5][3]++;
      cov_2g14hjv15x.s[21]++;
      pos.left = scrollLeft + rect.left - containerRect.left;
      cov_2g14hjv15x.s[22]++;
      pos.top = scrollTop + rect.top - containerRect.top;
      cov_2g14hjv15x.s[23]++;
      break;

    case 'left':
      cov_2g14hjv15x.b[5][4]++;
      cov_2g14hjv15x.s[24]++;
      pos.left = scrollLeft + rect.left - containerRect.left;
      cov_2g14hjv15x.s[25]++;
      pos.top = scrollTop + rect.top - containerRect.top + rect.height / 2;
      cov_2g14hjv15x.s[26]++;
      break;

    case 'left-bottom':
      cov_2g14hjv15x.b[5][5]++;
      cov_2g14hjv15x.s[27]++;
      pos.left = scrollLeft + rect.left - containerRect.left;
      cov_2g14hjv15x.s[28]++;
      pos.top = scrollTop + rect.bottom - containerRect.bottom;
      cov_2g14hjv15x.s[29]++;
      break;

    case 'right-top':
      cov_2g14hjv15x.b[5][6]++;
      cov_2g14hjv15x.s[30]++;
      pos.left = scrollLeft + rect.left - containerRect.left + rect.width;
      cov_2g14hjv15x.s[31]++;
      pos.top = scrollTop + rect.top - containerRect.top;
      cov_2g14hjv15x.s[32]++;
      break;

    case 'right':
      cov_2g14hjv15x.b[5][7]++;
      cov_2g14hjv15x.s[33]++;
      pos.left = scrollLeft + rect.left - containerRect.left + rect.width;
      cov_2g14hjv15x.s[34]++;
      pos.top = scrollTop + rect.top - containerRect.top + rect.height / 2;
      cov_2g14hjv15x.s[35]++;
      break;

    case 'right-bottom':
      cov_2g14hjv15x.b[5][8]++;
      cov_2g14hjv15x.s[36]++;
      pos.left = scrollLeft + rect.left - containerRect.left + rect.width;
      cov_2g14hjv15x.s[37]++;
      pos.top = scrollTop + rect.bottom - containerRect.bottom;
      cov_2g14hjv15x.s[38]++;
      break;

    case 'bottom-left':
      cov_2g14hjv15x.b[5][9]++;
      cov_2g14hjv15x.s[39]++;
      pos.left = scrollLeft + rect.left - containerRect.left;
      cov_2g14hjv15x.s[40]++;
      pos.top = scrollTop + rect.top - containerRect.top + rect.height;
      cov_2g14hjv15x.s[41]++;
      break;

    case 'bottom':
      cov_2g14hjv15x.b[5][10]++;
      cov_2g14hjv15x.s[42]++;
      pos.left = scrollLeft + rect.left - containerRect.left + rect.width / 2;
      cov_2g14hjv15x.s[43]++;
      pos.top = scrollTop + rect.top - containerRect.top + rect.height;
      cov_2g14hjv15x.s[44]++;
      break;

    case 'bottom-right':
      cov_2g14hjv15x.b[5][11]++;
      cov_2g14hjv15x.s[45]++;
      pos.right = ((cov_2g14hjv15x.b[7][0]++, containerRect.right) || (cov_2g14hjv15x.b[7][1]++, docSize.width)) - rect.right - scrollLeft;
      cov_2g14hjv15x.s[46]++;
      pos.top = scrollTop + rect.top - containerRect.top + rect.height;
      cov_2g14hjv15x.s[47]++;
      break;

    case 'cover':
      cov_2g14hjv15x.b[5][12]++;
      cov_2g14hjv15x.s[48]++;
      pos.left = scrollLeft + rect.left - containerRect.left;
      cov_2g14hjv15x.s[49]++;
      pos.top = scrollTop + rect.top - containerRect.top;
      cov_2g14hjv15x.s[50]++;
      break;

    default:
      cov_2g14hjv15x.b[5][13]++;
  }

  cov_2g14hjv15x.s[51]++;
  return posKeys.reduce(function (data, key) {
    cov_2g14hjv15x.f[1]++;
    cov_2g14hjv15x.s[52]++;
    return _objectSpread2(_objectSpread2({}, data), {}, _defineProperty({}, key, typeof pos[key] === 'number' ? (cov_2g14hjv15x.b[8][0]++, "".concat(Math.round(pos[key]), "px")) : (cov_2g14hjv15x.b[8][1]++, 'auto')));
  }, {});
};